import React from 'react';
import { Box, Heading, Text, TextButton } from '@wix/design-system';
import { RefreshSmall } from '@wix/wix-ui-icons-common/lazy';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
export const BusinessNamesError = _ref => {
  let onRetry = _ref.onRetry;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    align: "center",
    textAlign: "center",
    padding: "SP6",
    gap: "SP2",
    dataHook: "business-names-error"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "medium"
  }, t('domain_search_gate.bng_results.error.names_section.title')), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    secondary: true
  }, t('domain_search_gate.bng_results.error.names_section.description')), onRetry && /*#__PURE__*/React.createElement(TextButton, {
    onClick: onRetry,
    prefixIcon: /*#__PURE__*/React.createElement(RefreshSmall, null)
  }, t('domain_search_gate.bng_results.error.names_section.try_again.cta')));
};
//# sourceMappingURL=BusinessNamesError.js.map